import { useEffect, useState } from "react"

/**
 * React hook that tracks state of a CSS media query
 *
 * @param query the media query to match
 *
 */
export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const win = window
    setMatches(win.matchMedia(query).matches)

    const mql = win.matchMedia(query)

    const handler = (evt: MediaQueryListEvent) => {
      setMatches(evt.matches)
    }

    mql.addEventListener("change", handler)

    return () => {
      mql.removeEventListener("change", handler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return [matches]
}
